import React from 'react';
import { Modal } from './ui/Modal';
import { ImageUpload } from './ImageUpload';

interface VehicleImageUploadModalProps {
  isOpen: boolean;
  onClose: () => void;
  vehicleId: number;
  heroImageCount: number;
  error: string | null;
  onErrorClear: () => void;
  onImageUploaded: (imageData: unknown) => void;
  onError: (message: string) => void;
}

export const VehicleImageUploadModal: React.FC<VehicleImageUploadModalProps> = ({
  isOpen,
  onClose,
  vehicleId,
  heroImageCount,
  error,
  onErrorClear,
  onImageUploaded,
  onError,
}) => {
  const handleClose = () => {
    onErrorClear();
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Upload Vehicle Photos"
      size="lg"
    >
      {error && (
        <div className="mb-4 p-4 bg-red-900/50 border border-red-500 rounded-lg">
          <div className="flex items-start space-x-3">
            <div className="flex-1">
              <h3 className="text-sm font-medium text-red-400 mb-1">Upload Error</h3>
              <div className="text-sm text-red-300 whitespace-pre-line">{error}</div>
              <p className="text-xs text-red-400 mt-2">
                Images must be under 10MB (JPEG, PNG, WebP, or GIF).
              </p>
            </div>
            <button
              type="button"
              onClick={onErrorClear}
              className="text-red-400 hover:text-red-300 transition-colors"
              aria-label="Dismiss error"
            >
              ×
            </button>
          </div>
        </div>
      )}

      <ImageUpload
        vehicleId={vehicleId}
        imageType="hero"
        onImageUploaded={onImageUploaded}
        onError={onError}
        maxFiles={Math.max(0, 4 - heroImageCount)}
        onUploadComplete={handleClose}
      />
    </Modal>
  );
};
